import React, { Component } from 'react'
import { connect } from 'react-redux';
let RealBlockAdminMenu = null;

class BlockAdminMenu extends Component {
  	constructor(props) {
    	super(props);
    	this.state = { isReady: RealBlockAdminMenu !== null };
  	}

  	componentWillMount() {
  		const {isAdmin} = this.props
  		
  		if(!isAdmin) return
  		this.load()
  	}
  	
	componentWillReceiveProps({isAdmin}) {
		if((isAdmin) && !RealBlockAdminMenu) this.load()
	}

  	load() {
    	require.ensure('./admin', () => {
      		RealBlockAdminMenu = require('./admin').RealBlockAdminMenu;
      		if (!this.hasUnmounted) {
      			this.setState({ isReady: true });
      		}
    	});
  	}

  	componentWillUnmount() {
    	this.hasUnmounted = true;
  	}

  	render() {
		return this.state.isReady ? <RealBlockAdminMenu {...this.props} /> : null
  	}
}

export default connect(state => ({isEditor: state.auth.isEditor, isAdmin: state.auth.isAdmin}))(BlockAdminMenu);



// WEBPACK FOOTER //
// ./src/fm/admin/BlockAdminMenu.js